import JobsRepositories from "../repositories/jobs.repositories"
import { Job, JobDetailParams, JobQuery, RelatedJobQueryParams } from "@interfaces/career"
import { PaginationData } from "@interfaces/misc"
import { Result } from "@lib/api/services/result"

export default class JobsServices extends JobsRepositories {
  async getJobsList(query?: Partial<JobQuery>) {
    try {
      const res = await this.getRawJobs(query)
      const response = await this._getResponse<PaginationData<Job>>(res)

      const { error, result } = response

      if (error) {
        return Result.fail<PaginationData<Job>>()
      }

      return Result.ok<PaginationData<Job>>(result)
    } catch (e: any) {
      return Result.fail<PaginationData<Job>>()
    }
  }

  async getJobDetail({ category_id, position_id }: JobDetailParams) {
    try {
      const res = await this.getRawJobDetail(category_id, position_id)
      const response = await this._getResponse<Job>(res)
      if (response.error) {
        return Result.fail<Job>()
      }
      return Result.ok<Job>(response.result)
    } catch (e: any) {
      return Result.fail<Job>()
    }
  }

  async getRelatedJobs({ category_name, career_id }: RelatedJobQueryParams) {
    try {
      const res = await this.getRawRelatedJobs(category_name, career_id)
      const response = await this._getResponse<Job[]>(res)
      if (response.error) {
        return Result.fail<any>()
      }
      return Result.ok<Job[]>(response.result)
    } catch (e: any) {
      return Result.fail<any>()
    }
  }
}
